import React from 'react';
import { 
  FolderOutlined, 
  DeleteOutlined, 
  SwapOutlined,
  EllipsisOutlined
} from '@ant-design/icons';
import { Button } from 'antd';
import { IconGridView, IconCard, DropdownActions } from '../../common';

const BatchIconView = ({ batches, onViewOrders, onAssignAirwayBill, onDeleteBatch }) => {
  const getActions = (batch) => [
    {
      key: 'assign',
      icon: <SwapOutlined />,
      label: '分配空运单',
      onClick: ({ domEvent }) => {
        if (domEvent) {
          domEvent.stopPropagation();
        }
        onAssignAirwayBill(domEvent, batch.id);
      }
    },
    {
      key: 'delete',
      icon: <DeleteOutlined />,
      label: '删除批次',
      danger: true,
      onClick: ({ domEvent }) => {
        if (domEvent) {
          domEvent.stopPropagation();
        }
        onDeleteBatch(domEvent, batch.id);
      }
    }
  ];

  return (
    <IconGridView
      items={batches}
      renderCard={(batch) => (
        <IconCard
          icon={<FolderOutlined />}
          title={batch.batch_number}
          subtitle={`客户: ${batch.customer_name}`}
          extraInfo={[
            `订单数量: ${batch.order_count}`,
            `空运单: ${batch.airway_bill_number || '未分配'}`
          ]}
          onClick={() => onViewOrders(batch)}
          dropdownItems={getActions(batch)}
          dropdownTrigger={
            <Button 
              type="text" 
              icon={<EllipsisOutlined style={{ fontSize: '20px' }} />}
            />
          }
        />
      )}
    />
  );
};

export default BatchIconView;
